<template>
  <footer class="global-disclaimer" :data-version="version">
    <span class="disclaimer-label">说明</span>
    <span>{{ text }}</span>
  </footer>
</template>

<script>
import { DISCLAIMER_VERSION, GLOBAL_DISCLAIMER_TEXT } from '@/constants/compliance';

export default {
  name: 'GlobalDisclaimer',
  props: {
    version: {
      type: String,
      default: DISCLAIMER_VERSION
    }
  },
  data() {
    return {
      text: GLOBAL_DISCLAIMER_TEXT
    };
  }
};
</script>

<style scoped lang="scss">
.global-disclaimer {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin: 20px 12px 12px;
  padding: 12px 12px calc(12px + env(safe-area-inset-bottom));
  border: 1px solid #edf1f7;
  border-radius: 12px;
  background: #f8fafc;
  color: #7d8798;
  font-size: 11px;
  line-height: 1.65;
  text-align: left;
}

.disclaimer-label {
  flex: 0 0 auto;
  margin-top: 2px;
  padding: 1px 6px;
  border-radius: 999px;
  background: #eef4ff;
  color: #003cbf;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.5;
}
</style>
